module.exports = __webpack_public_path__ + "media/images/veritrans_payment/Card_Master-3dd419beaab9307878a41e7a221aaf9d.gif";